import React, { useEffect, useRef, useState } from "react";
import { X, Eraser, Trash2 } from "lucide-react";

const PALETTE = ["#0A0A0A", "#FF3B30", "#3AA0FF", "#CCFF00", "#D4B3FF", "#FF9E80", "#00BFA5"];

export default function DoodleCanvas({ open, onClose, onSubmit }) {
  const canvasRef = useRef(null);
  const [color, setColor] = useState("#0A0A0A");
  const [size, setSize] = useState(4);
  const drawing = useRef(false);
  const last = useRef({ x: 0, y: 0 });

  useEffect(() => {
    if (!open) return;
    const c = canvasRef.current;
    if (!c) return;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
  }, [open]);

  if (!open) return null;

  const getPos = (e) => {
    const c = canvasRef.current;
    const rect = c.getBoundingClientRect();
    const t = e.touches?.[0];
    const clientX = t ? t.clientX : e.clientX;
    const clientY = t ? t.clientY : e.clientY;
    return {
      x: ((clientX - rect.left) * c.width) / rect.width,
      y: ((clientY - rect.top) * c.height) / rect.height,
    };
  };

  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    last.current = getPos(e);
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const p = getPos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.strokeStyle = color;
    ctx.lineWidth = size;
    ctx.beginPath();
    ctx.moveTo(last.current.x, last.current.y);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    last.current = p;
  };
  const end = () => { drawing.current = false; };

  const clear = () => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, c.width, c.height);
  };

  const submit = async () => {
    const c = canvasRef.current;
    const data = c.toDataURL("image/png");
    onSubmit(data);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" data-testid="doodle-dialog">
      <div className="bg-white border-hard shadow-hard-lg rounded-2xl p-5 w-full max-w-lg slide-up">
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-display text-2xl">Çizim yap</h2>
          <button onClick={onClose} data-testid="doodle-close-btn" className="w-9 h-9 border-hard-2 rounded-lg flex items-center justify-center press-btn">
            <X strokeWidth={3} className="w-4 h-4" />
          </button>
        </div>

        <canvas
          ref={canvasRef}
          width={520}
          height={360}
          data-testid="doodle-canvas"
          onMouseDown={start}
          onMouseMove={move}
          onMouseUp={end}
          onMouseLeave={end}
          onTouchStart={start}
          onTouchMove={move}
          onTouchEnd={end}
          className="w-full aspect-[13/9] bg-white border-hard rounded-xl cursor-crosshair touch-none"
        />

        <div className="mt-3 flex items-center gap-2 flex-wrap">
          {PALETTE.map((c) => (
            <button
              key={c}
              onClick={() => setColor(c)}
              data-testid={`doodle-color-${c}`}
              className={`w-8 h-8 rounded-full border-hard-2 press-btn ${color === c ? "shadow-hard-sm" : ""}`}
              style={{ background: c }}
              aria-label={c}
            />
          ))}
          <div className="flex items-center gap-2 ml-2">
            <span className="text-xs font-black uppercase tracking-widest">Kalınlık</span>
            <input type="range" min={2} max={20} value={size} onChange={(e) => setSize(Number(e.target.value))} data-testid="doodle-size-input" />
          </div>
          <button onClick={clear} data-testid="doodle-clear-btn" className="ml-auto border-hard-2 rounded-lg px-3 py-2 text-xs font-black uppercase press-btn flex items-center gap-1">
            <Trash2 strokeWidth={3} className="w-4 h-4" /> Temizle
          </button>
        </div>

        <button onClick={submit} data-testid="doodle-submit-btn" className="mt-4 w-full bg-[#CCFF00] border-hard shadow-hard rounded-xl px-5 py-3 font-black press-btn">
          Çizimi gönder
        </button>
      </div>
    </div>
  );
}
